import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UsersList from "../../Modals/usersList";
import { useLazyGetNotificationDetailQuery } from "../../service/notifications";
import { useParams } from "react-router-dom";
import { useLazyGetUsersQuery } from "../../service/users";
import { showError } from "../../constants/toasts";
import { NOTIFICATION_TYPE } from "../../constants/enums";
import { Notification } from "../../types/General";

const NotificationDetail = () => {
  const { id } = useParams();
  const [fetchNotificationDetail] = useLazyGetNotificationDetailQuery();
  const [getUserList] = useLazyGetUsersQuery();

  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const [notification, setNotification] = React.useState<any | null>(null);

  const [usersList, setUsersList] = React.useState<
    { id: string; label: string; avatar: string }[]
  >([]);

  useEffect(() => {
    getUsers();
    getNotificationDetail();
  }, [id]);

  const getUsers = async (p?: number) => {
    try {
      const response = await getUserList({
        page: 1,
        limit: 1000,
      }).unwrap();
      if (response.code === 200) {
        const data = response.data.list;
        const users = data.map((user: any) => ({
          label: `${user?.firstName ? user?.firstName : ""} ${
            user?.lastName ? user?.lastName : ""
          }`,
          id: user?._id,
          avatar: user?.image,
        }));
        setUsersList(users);
      }
    } catch (error: any) {
      showError(error.data.message || "");
    }
  };

  const getNotificationDetail = async () => {
    try {
      if (!id) return;
      const response = await fetchNotificationDetail({ id: id! });
      if (response?.data) {
        console.log(response?.data);
        setNotification(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching notification:", error);
    }
  };

  const handleOpenAudience = (userIds: string[]) => {
    setSelectedUserIds(userIds);
    setOpenUserModal(true);
  };

  const getUserLabel = (row: Notification) => {
    if (row?.isSendToAll) return "All Users";
    return `${row?.broadcastReceivers?.length} Users`;
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-notifications")}>
            Notification Management
          </button>{" "}
          - Notification Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          {/* <div className="vew_img no_radius w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div> */}
          <div className="w_100">
            <h6>Notification Title</h6>
            <p>{notification?.title || ""}</p>
          </div>
          <div className="w_33">
            <h6>Type</h6>
            <p>
              {NOTIFICATION_TYPE[
                notification?.type as keyof typeof NOTIFICATION_TYPE
              ] || notification?.type}
            </p>
          </div>
          {notification?.subject && (
            <div className="w_33">
              <h6>Subject</h6>
              <p>{notification?.subject || ""}</p>
            </div>
          )}
          <div className="w_33">
            <h6>Audience</h6>
            <p>
              <button
                className="anchor_link"
                onClick={() => {
                  if (notification?.broadcastReceivers?.length > 0) {
                    handleOpenAudience(notification?.broadcastReceivers);
                  }
                }}
              >
                {notification?.broadcastReceivers?.length > 0
                  ? getUserLabel(notification)
                  : "0 Users"}
              </button>
            </p>
          </div>
          {/* <div className="w_33">
            <h6>Schedule</h6>
            <p>Now - 09/01/2025 12:00 PM</p>
          </div> */}
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {new Date(notification?.createdAt || "").toLocaleDateString(
                "en-GB"
              )}
            </p>
          </div>
          <div className="w_100">
            <h6>Notification Message</h6>
            <p>{notification?.content || ""}</p>
          </div>
        </div>
      </div>

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationDetail;
